import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import EventTab from '../../components/event-tab'
import Partner from '../../components/partner'
import Footer from '../../components/footer'

import { studioImg } from '../../data/data'
import { servicesData } from '../../data/freelancer'

import client1 from '../../assets/images/client/01.jpg'

import {FiArrowRight, FiX} from '../../assets/icons/vander'

export default function IndexStudio() {
    let [show, setShow] = useState(false);
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 pb-0">
      <div className="container">
          <div className="row justity-content-center mt-5">
              <div className="col-12">
                  <div className="title-heading text-center">
                      <h4 className="heading fw-bold mb-3">Clean & Modern Design <br/> That’s Leaping Studio</h4>
                      <p className="para-desc mx-auto text-muted">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2 d-inline-block">
                          <VideoModalOne/>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container-fluid">
          <div id="grid" className="column-6">
            {studioImg.map((item,index)=>{
              return(
                  <div className="mb-3" key={index}>
                      <div className="card border-0 position-relative d-block shadow overflow-hidden rounded">
                          <div className="card-body p-0">
                              <img src={item} className="img-fluid" alt=""/>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {servicesData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-4 rounded">
                          <i className={`text-primary mdi-36px ${item.icon}`}></i>
                          <div className="content mt-2">
                              <h4 className="title">{item.title}</h4>
                              <p className="text-muted mt-2">{item.desc}</p>
                              <Link to="#" className="text-dark">Read More <i className="mdi mdi-chevron-right"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
      
      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                  <div className="text-center">
                      <h1 className="display-2"><i className="mdi mdi-format-quote-open text-primary"></i></h1>
                      <p className="text-muted h5 fst-italic">" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "</p>

                      <div className="mt-4">
                          <img src={client1} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                          <h6 className="text-primary mt-3 mb-0">Thomas Israel</h6>
                          <small className="text-muted">C.E.O</small>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-end mb-4 pb-4">
              <div className="col-md-8">
                  <div className="section-title text-center text-md-start">
                      <h4 className="title mb-4">Our Latest Works And Projects</h4>
                      <p className="text-muted mb-0 para-desc">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>

              <div className="col-md-4 mt-4 mt-sm-0">
                  <div className="text-center text-md-end">
                      <Link to="#" className="text-primary">View more suggesions <FiArrowRight className="fea icon-sm"/></Link>
                  </div>
              </div>
          </div>

          <EventTab/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-12">
                  <Partner/>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60" id="contactme">
          <div className="bg-dark bg-cta-dark rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4 className="text-white title-dark">Ready to start your project ?</h4>
                          <p className="text-white-50 para-desc para-dark mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="#" className="btn btn-outline-primary" onClick={()=>setShow(!show)}><i className="mdi mdi-phone-outline"></i> Contact Now</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      {show ? 
        <div className="modal fade show d-block" style={{backgroundColor:'#00000099'}}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content rounded shadow border-0">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalCenterTitle">Get In Touch ! </h5>
                        <button type="button" className="btn btn-icon btn-close" onClick={()=>setShow(!show)}><FiX className="fs-4 text-dark"/></button>
                    </div>
                    <div className="modal-body">
                        <div className="custom-form">
                            <form>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                            <input name="name" id="name" type="text" className="form-control" placeholder="Name :"/>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                            <input name="email" id="email" type="email" className="form-control" placeholder="Email :"/>
                                        </div> 
                                    </div>

                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Subject</label>
                                            <input name="subject" id="subject" className="form-control" placeholder="subject :"/>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Comments <span className="text-danger">*</span></label>
                                            <textarea name="comments" id="comments" rows="4" className="form-control" placeholder="Message :"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-grid">
                                            <button type="submit" id="submit" name="send" className="btn btn-primary">Send Message</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div> :""
      }
    </section>
    <Footer/>
    </>
  )
}
